import React from 'react'
import GeoJsonLayer from '../Leaflet/GeoJsonLayer'
import { prettyId, mapColorCategory } from '../../selectors/stompunkt'

export default ({ onClick, onShiftClick, stompunkter, markedStompunkter, showLabels, currentStompunkt }) => (
    <GeoJsonLayer
        onClick = {handleClick(onClick, onShiftClick)}
        features = {stompunkter}
        tooltip = {prettyId}
        style = {pointStyle(markedStompunkter, currentStompunkt)}
        permanentTooltips = {showLabels}
    />
)

function handleClick(onClick, onShiftClick) {
    onShiftClick = onShiftClick || onClick
    return (feature, event) => {
        event.shiftKey
            ? onShiftClick(feature.properties.stompunktId)
            : onClick(feature.properties.stompunktId)
    }
}

function pointStyle(markedStompunkter, currentStompunkt) {
    const markedSet = new Set(markedStompunkter)
    return (stompunkt) => {
        let isSelected = markedSet.has(stompunkt.id)
        let isCurrent = currentStompunkt ? currentStompunkt.id === stompunkt.id : false;
        return {
            radius: 6,
            fillColor: pointColors[mapColorCategory(stompunkt)],
            color: "#000",
            weight: isSelected ? 3 : isCurrent ? 2 : 1,
            opacity: isSelected ? 1 : isCurrent ? 1 : 0.65,
            fillOpacity: isSelected ? 1 : 0.65,
        }
    }
}

const pointColors = {
    sweref: '#F0F', // '#fdb71e', // Senapsgul/orange, //'#F0F', // Rosa,
    rix95: '#F00', // Röd
    riksavvägningen: '#00F', // Blå
    förstörd: '#D3D3D3' // Grå
}



// WEBPACK FOOTER //
// ./src/components/Map/StompunktLayer.js